import { unsubscribe } from "pubsub-js";

export const unsubscribeEvent = (token: string) => {
  unsubscribe(token);
};
